import { render, staticRenderFns } from "./OrderItems.vue?vue&type=template&id=56c6337c&"
import script from "./OrderItems.vue?vue&type=script&lang=js&"
export * from "./OrderItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56c6337c')) {
      api.createRecord('56c6337c', component.options)
    } else {
      api.reload('56c6337c', component.options)
    }
    module.hot.accept("./OrderItems.vue?vue&type=template&id=56c6337c&", function () {
      api.rerender('56c6337c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/rd/OrderItems.vue"
export default component.exports